<template>
  <div id="wrapper" class="page" v-if="leaveschedule_report">
    <div id="content-wrapper" style="height: 100%;">
      <div class="container-fluid">
        <span style="display: inline;">
          <div class="form-inline" style="width: 100%">
            <b-form-input
              style="flex-grow: 1"
              v-model="query"
              placeholder="Filter by employee code, name"
              @keydown.enter.prevent="queryItem"
            ></b-form-input>
            <button class="btn" @click.prevent="queryItem">
              <i class="fas fa-search"></i>
            </button>
          </div>

          <b-table
            id="my-table"
            bordered
            head-variant="dark"
            hover
            responsive
            striped
            small
            table-variant="light"
            :fields="fields"
            :items="items"
            @sort-changed="sortChanged"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template #head(lastyearRemainDays)>
              Remaining Days ({{ new Date().getFullYear() - 1 }})
              <!-- Remaining time-off Days from
                    {{ new Date().getFullYear() - 1 }} -->
            </template>
            <template #head(lastyearTakendays)>
              Taken time-off days
              {{ new Date().getFullYear() - 1 }}
            </template>
            <template #head(expired31_03TODays)>
              Expired by 31/03/{{ new Date().getFullYear() }}
            </template>
            <template #head(totalTODays)>
              Total <br />time-off days in
              {{ new Date().getFullYear() }}
            </template>
            <template #head(usedDays)>
              Time-off Days Used in {{ new Date().getFullYear() }}
            </template>
            <template #cell(STT)="data">{{ data.index + 1 }}</template>
            <template #cell(ngayvaonganh)="data">{{
              data.item.ngayvaonganh | moment("DD/MM/YYYY")
            }}</template>
            <template v-slot:cell(lastyearRemainDays)="data">{{
              data.item.lastyearRemainDays
            }}</template>
            <template v-slot:cell(lastyearTakendays)="data">{{
              data.item.lastyearUsedDays
            }}</template>
            <template v-slot:cell(expired31_03TODays)="data">{{
              data.item.lastyearRemainDays - data.item.lastyearUsedDays
            }}</template>
            <template v-slot:cell(totalTODays)="data">{{
              data.item.timeOffDays
            }}</template>
            <template v-slot:cell(usedDays)="data">{{
              data.item.usedDays - data.item.lastyearUsedDays
            }}</template>
            <template v-slot:cell(remainDays)="data"
              ><strong>{{ data.item.remainDays }}</strong></template
            >
            >
          </b-table>
          <!-- <b-badge v-if="totalRow != 0" variant="light"
              >Tổng số khách hàng: {{ totalRow }}</b-badge
            > -->
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LeaveScheduleReport",
  components: {},
  data() {
    return {
      fields: [
        {
          key: "STT",
          // label: "STT",
          label: "No.",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "manhanvien",
          label: "Code",
          // label: "Mã NV",
          sortable: true,
          thClass: "align-middle",
          tdClass: "text-center",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "hovaten",
          label: "Name",
          // label: "Họ và tên",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "440px !important", textAlign: "center" },
        },
        {
          key: "donvicongtac",
          label: "Company",
          // label: "Công ty",
          sortable: true,
          thClass: "align-middle",
          tdClass: "text-center",
          thStyle: { width: "80px", textAlign: "center" },
        },
        {
          key: "vitricongviec",
          label: "Position",
          // label: "Chức danh",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "180px", textAlign: "center" },
        },
        {
          key: "ngayvaonganh",
          label: "Start Date",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "120px", textAlign: "center" },
        },
        {
          key: "thanglamviec",
          label: "Working Months",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "90px", textAlign: "center" },
        },
        {
          key: "lastyearRemainDays",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "90px",
            minWidth: "90px",
            textAlign: "center",
          },
        },
        {
          key: "lastyearTakendays",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "90px",
            minWidth: "90px",
            textAlign: "center",
          },
        },
        {
          key: "expired31_03TODays",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "90px",
            minWidth: "90px",
            textAlign: "center",
          },
        },
        {
          key: "totalTODays",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "90px",
            minWidth: "90px",
            textAlign: "center",
          },
        },
        {
          key: "usedDays",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "90px",
            minWidth: "90px",
            textAlign: "center",
          },
        },
        {
          key: "remainDays",
          sortable: true,
          tdClass: "text-center",
          label: "Remaining Time-off Days",
          thClass: "align-middle",
          thStyle: {
            width: "95px",
            minWidth: "95px",
            textAlign: "center",
          },
        },
        {
          key: "t1",
          label: "T1",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t1 == 0) return "";
            return item.t1;
          },
        },
        {
          key: "t2",
          label: "T2",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t2 == 0) return "";
            return item.t2;
          },
        },
        {
          key: "t3",
          label: "T3",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t3 == 0) return "";
            return item.t3;
          },
        },
        {
          key: "t4",
          label: "T4",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t4 == 0) return "";
            return item.t4;
          },
        },
        {
          key: "t5",
          label: "T5",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t5 == 0) return "";
            return item.t5;
          },
        },
        {
          key: "t6",
          label: "T6",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t6 == 0) return "";
            return item.t6;
          },
        },
        {
          key: "t7",
          label: "T7",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t7 == 0) return "";
            return item.t7;
          },
        },
        {
          key: "t8",
          label: "T8",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t8 == 0) return "";
            return item.t8;
          },
        },
        {
          key: "t9",
          label: "T9",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t9 == 0) return "";
            return item.t9;
          },
        },
        {
          key: "t10",
          label: "T10",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t10 == 0) return "";
            return item.t10;
          },
        },
        {
          key: "t11",
          label: "T11",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t11 == 0) return "";
            return item.t11;
          },
        },
        {
          key: "t12",
          label: "T12",
          sortable: true,
          tdClass: "text-center", //tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { width: "30px", textAlign: "center" },
          formatter: (value, key, item) => {
            if (item.t12 == 0) return "";
            return item.t12;
          },
        },
      ],
      items: [],
    };
  },
  computed: {
    //Permission
    leaveschedule_report() {
      return this.$store.getters.hasPermission("leaveschedule_report");
    },
    getCurrentYear() {
      return "Con heo";
    },
  },

  beforeRouteEnter(to, from, next) {
    axios
      .get("/api/leaveschedule/show")
      .then((response) => {
        next((vm) => vm.initData(response.data));
      })
      .catch((err) => {
        this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        // next();
      });
  },
  methods: {
    initData(data) {
      this.items = data;
    },
    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.report = this.report;
      //Report 1 - Tham so cho excel
      if (this.report == 1) query.customer = this.customer;
      axios({
        method: "get",
        url: `/api/CustomerContractReport/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {});
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;

      axios.get("/api/leaveschedule/show", { params: query }).then((res) => {
        this.items = res.data;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
